const API_RESPONSE_STATE_TEMPLATE = {
  data: {},
  headers: {},
  status: null,
  statusMessage: null,
}

export { API_RESPONSE_STATE_TEMPLATE }
